document.addEventListener("DOMContentLoaded", () => {
  const thumbsWrapper = document.querySelector(
    '.product-media--thumbs-wrapper[data-scrollable="true"]',
  );
  if (!thumbsWrapper) return;

  const isFullyVisibleInWrapper = (thumbEl) => {
    const wrapperRect = thumbsWrapper.getBoundingClientRect();
    const thumbRect = thumbEl.getBoundingClientRect();
    return (
      thumbRect.left >= wrapperRect.left && thumbRect.right <= wrapperRect.right
    );
  };

  const thumbs = thumbsWrapper.querySelectorAll(".product-media--thumb");
  if (!thumbs.length > 0) return;

  thumbs.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      if (!isFullyVisibleInWrapper(thumb)) {
        thumb.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "nearest",
        });
      }
    });
  });
});